export default [
  {
    path: 'purchase/shopgoods',
    name: 'purchaseShopgoods',
    meta: {
      title:'采购 / 店铺商品管理',
      isRefresh:true
    },
    component: () => import('@/views/purchase/shopGoods')
  }
]


// WEBPACK FOOTER //
// ./src/router/purchase.route.js